import { PureComponent, Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Icon, Modal, Tab, Form, Label } from 'semantic-ui-react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import {
  getDomains,
  postOutcomes,
  getOutcomes,
  getOutcomesWithTranslations,
} from '../../../../store/actions';

import { map } from '../../../../utils/lodash';
import { CustomAccordion, CustomTable } from '../../../../components';
import MultiLanguageInput from '../../../../components/form/inputs/multiLanguageInput';
import MultiLanguageTextArea from '../../../../components/form/inputs/multiLanguageTextArea';
import { CustomDropdown } from '../../../../components/form';
import { SUPPORTED_LANGUAGES } from '../../../../i18n';

import {
  initialValues,
  outcomeValidation,
  convertToBackendFormat,
} from '../../../../validations/addOutcomeValidation';

import EditModalOutcome from './EditModalOutcome';
import EditModalGradedOutcome from './EditModalGradedOutcome';

import '../../admin.scss';

class OutcomesParent extends Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: 'formal' };
  }

  componentDidMount() {
    const { getOutcomes, getOutcomesWithTranslations } = this.props;
    getOutcomes();
    getOutcomesWithTranslations();
  }

  render() {
    const { t } = this.props;
    const { activeTab } = this.state;

    return (
      <div className="no-color">
        <div className="tabs-ctr tabs-ctr--style2 tabs-ctr--ucase-tabs">
          <button
            className={`tab ${activeTab === 'formal' ? 'active' : ''}`}
            onClick={() => this.setState({ activeTab: 'formal' })}
          >
            {t('outcomes.formal')}
          </button>
          <button
            className={`tab ${activeTab === 'graded' ? 'active' : ''}`}
            onClick={() => this.setState({ activeTab: 'graded' })}
          >
            {t('outcomes.graded')}
          </button>
        </div>

        {/* ── Formal tab — existing list + Add Outcome button ── */}
        {activeTab === 'formal' && (
          <>
            <OutcomeActions {...this.props} />
            <OutcomePolicy {...this.props} />
          </>
        )}

        {/* ── Graded tab — same list with Graded edit modal ── */}
        {activeTab === 'graded' && <GradedOutcomePolicy {...this.props} />}
      </div>
    );
  }
}

class OutcomeActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
    };
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  componentDidMount() {
    const { getDomains } = this.props;
    getDomains();
  }

  render() {
    const { modal } = this.state;
    const { domains, t } = this.props;

    return (
      <div className="outcome-admin-custom">
        <div>
          <Modal
            open={modal}
            onOpen={() => this.toggle()}
            closeIcon={
              <Icon
                onClick={() => this.toggle()}
                name="close"
                className="closeicon"
              />
            }
            size="small"
            trigger={
              <Button className="Primary-Button">
                <div className="add-icon-activity-add">
                  <Icon name="plus circle" />
                  <div className="add-text">
                    {t('admin.activity_settings.outcomes.add_outcome')}
                  </div>
                </div>
              </Button>
            }
            className="create-outcome"
          >
            <Modal.Header>
              {t('admin.activity_settings.outcomes.create_outcome')}
            </Modal.Header>
            <Modal.Content>
              <CreateOutcome
                domains={domains}
                toggle={() => this.toggle()}
                {...this.props}
              />
            </Modal.Content>
          </Modal>
        </div>
      </div>
    );
  }
}

class OutcomePolicy extends Component {
  render() {
    const { policies } = this.props;

    return (
      <div className="gap-between-windows">
        {map(policies, (policy, i) => (
          <div key={i} className="gap-between-windows">
            <CustomAccordion
              className="accordion-ev"
              title={policy.policyName}
              children={<OutcomeTypes policy={policy} {...this.props} />}
              collapse={true}
            />
          </div>
        ))}
      </div>
    );
  }
}

class OutcomeTypes extends Component {
  renderColumns() {
    const { t, i18n } = this.props;
    const columns = [
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('common.name')}</strong>
          </div>
        ),
        render: (data) => {
          // Handle multilingual titles - show English as fallback
          const displayTitle = data.translations?.title?.en || data.title;
          return (
            <div className="blocked-badge-container">
              <div className={!data.isEnable && 'disabled'}>{displayTitle}</div>
              {!data.isEnable && (
                <Label className="blocked-badge" color="red" size="tiny">
                  {t('common.disabled')}
                </Label>
              )}
            </div>
          );
        },
        width: 8,
      },
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('common.created_date')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className={!data.isEnable && 'disabled'}>
              {new Intl.DateTimeFormat(i18n.language, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
              }).format(new Date(data.createdAt))}
            </div>
          );
        },
        width: 3,
      },
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('common.updated_date')}</strong>
          </div>
        ),
        render: (data) => {
          return (
            <div className={!data.isEnable && 'disabled'}>
              {new Intl.DateTimeFormat(i18n.language, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
              }).format(new Date(data.updatedAt))}
            </div>
          );
        },
        width: 3,
      },
      {
        title: '',
        render: (data) => {
          return <EditModalOutcome {...this.props} item={data} />;
        },
        width: 2,
      },
    ];

    return columns;
  }

  render() {
    const { outcomesWithTranslations, policy, t } = this.props;

    const selectedOutcomes = [];
    (outcomesWithTranslations || []).forEach((item, i) => {
      if (item.policyId !== policy.id) return null;
      selectedOutcomes.push(item);
    });

    return (
      <div className="view-accordion-com">
        <div className="scroll-accordion">
          <CustomTable
            header
            customClass="super-admin-table tbody-hover"
            columns={this.renderColumns()}
            data={selectedOutcomes}
            emptyMessage={t('common.no_tooltips')}
            keyExtractor={(item, index) => item.id}
            arrowed={false}
          />
        </div>
      </div>
    );
  }
}

class CreateOutcome extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentLanguage: 'en',
    };
  }

  async handleValidSubmit(values) {
    try {
      const { postOutcomes, toggle } = this.props;
      const legacyData = convertToBackendFormat(values);

      await postOutcomes(legacyData);
      toggle();
    } catch (error) {
      console.error('Error: CreateOutcome ~ handleValidSubmit', error);
    }
  }

  selectDomain() {
    const { domains } = this.props;
    return (domains || []).map((item, i) => ({
      key: item.id,
      text: item.policyName,
      value: item.id,
    }));
  }

  // Get reference values for translation
  getReferenceValue = (fieldName, values) => {
    if (this.state.currentLanguage === 'en') return '';
    return values[fieldName]?.en || '';
  };

  render() {
    const { toggle, outcomeLoading, t } = this.props;

    return (
      <div className="multilingual-outcome-form">
        <Formik
          onSubmit={(values) => this.handleValidSubmit(values)}
          initialValues={initialValues()}
          validationSchema={outcomeValidation(t)}
          context={{ isMultiLang: true }}
        >
          {({ handleSubmit, values }) => {
            // Create language tabs
            const languageTabs = SUPPORTED_LANGUAGES.map(
              (lang) =>
                lang.menu && {
                  menuItem: {
                    key: lang.locale,
                    content: (
                      <span>
                        {lang.flag} {lang.name}
                        {lang.locale === 'en' && (
                          <span style={{ color: '#f39c12' }}> *</span>
                        )}
                      </span>
                    ),
                  },
                  render: () => (
                    <Tab.Pane key={lang.locale}>
                      <Form onSubmit={handleSubmit} className="venue-form">
                        <MultiLanguageInput
                          id="title"
                          name="title"
                          placeholder={t('formulary.placeholder.enter_title')}
                          labelText={t('formulary.title')}
                          requiredStar
                          currentLanguage={lang.locale}
                          referenceValue={this.getReferenceValue(
                            'title',
                            values
                          )}
                        />

                        <MultiLanguageTextArea
                          id="description"
                          name="description"
                          placeholder={t(
                            'formulary.placeholder.enter_description'
                          )}
                          labelText={t('common.description')}
                          requiredStar
                          currentLanguage={lang.locale}
                          referenceValue={this.getReferenceValue(
                            'description',
                            values
                          )}
                        />

                        {lang.locale === 'en' && (
                          <CustomDropdown
                            id="policyId"
                            name="policyId"
                            labelText={t('formulary.domain')}
                            placeholder={t(
                              'formulary.placeholder.select_a_domain'
                            )}
                            options={this.selectDomain()}
                            requiredStar
                          />
                        )}

                        <div className="model-buttons">
                          <Button
                            className="Secondary-Button"
                            type="button"
                            onClick={() => toggle()}
                          >
                            {t('actions.cancel')}
                          </Button>
                          <Button
                            content={t('actions.create')}
                            type="submit"
                            className="Primary-Button"
                            loading={outcomeLoading}
                            disabled={outcomeLoading}
                          />
                        </div>
                      </Form>
                    </Tab.Pane>
                  ),
                }
            );

            return (
              <Tab
                panes={languageTabs}
                onTabChange={(e, { activeIndex }) => {
                  const selectedLang = SUPPORTED_LANGUAGES[activeIndex];
                  this.setState({ currentLanguage: selectedLang.locale });
                }}
              />
            );
          }}
        </Formik>
      </div>
    );
  }
}

class GradedOutcomePolicy extends Component {
  render() {
    const { policies } = this.props;
    return (
      <div className="gap-between-windows">
        {map(policies, (policy, i) => (
          <div key={i} className="gap-between-windows">
            <CustomAccordion
              className="accordion-ev"
              title={policy.policyName}
              children={<GradedOutcomeTypes policy={policy} {...this.props} />}
              collapse={true}
            />
          </div>
        ))}
      </div>
    );
  }
}

class GradedOutcomeTypes extends Component {
  renderColumns() {
    const { t } = this.props;

    const columns = [
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('outcomes.graded_title')}</strong>
          </div>
        ),
        render: (data) => (
          <div
            style={{
              color: data.graded ? '#111827' : '#9ca3af',
              fontStyle: data.graded ? 'normal' : 'italic',
            }}
          >
            {data.graded || t('outcomes.not_set_click_edit_to_add')}
          </div>
        ),
        width: 4,
      },
      {
        title: (
          <div className="user-act-heading-container-custom-feature">
            <strong>{t('outcomes.formal_title')}</strong>
          </div>
        ),
        render: (data) => (
          <div className="blocked-badge-container">
            <div className={!data.isEnable ? 'disabled' : ''}>{data.title}</div>
          </div>
        ),
        width: 4,
      },
      {
        title: '',
        render: (data) => (
          <EditModalGradedOutcome {...this.props} item={data} />
        ),
        width: 2,
      },
    ];
    return columns;
  }

  render() {
    const { t, outcomesWithTranslations, policy } = this.props;

    const selectedOutcomes = [];
    (outcomesWithTranslations || []).forEach((item) => {
      if (item.policyId !== policy.id) {
        return null;
      }
      selectedOutcomes.push(item);
    });

    return (
      <div className="view-accordion-com">
        <div className="scroll-accordion">
          <CustomTable
            header
            customClass="super-admin-table tbody-hover"
            columns={this.renderColumns()}
            data={selectedOutcomes}
            emptyMessage={t('formulary.no_outcomes')}
            keyExtractor={(item) => item.id}
            arrowed={false}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    domains: state.admin.domains,
    outcomeLoading: state.admin.outcomeLoading,
    outcomes: state.extra.outcomes,
    outcomesWithTranslations: state.extra.outcomesWithTranslations,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getDomains,
      postOutcomes,
      getOutcomes,
      getOutcomesWithTranslations,
    },
    dispatch
  );
};

OutcomesParent = connect(mapStateToProps, mapDispatchToProps)(OutcomesParent);
OutcomesParent = withTranslation()(OutcomesParent);

OutcomeTypes = withTranslation()(OutcomeTypes);
OutcomeActions = withTranslation()(OutcomeActions);
CreateOutcome = withTranslation()(CreateOutcome);

export { OutcomesParent };
